import { ButtonBase, Typography } from '@material-ui/core'
import React from 'react'

import { LocalizedLink } from '../../routes/localizedRoutes'
import { Channel } from '../../types/channel'
import useStyles from './styles/ChannelsTable.styles'

interface ChannelRowMobileProps {
  data: Channel
}

const ChannelRowMobile: React.FC<ChannelRowMobileProps> = ({ data }) => {
  const {
    basicDetails: { name, displayChannelCode, channelCode, channelID }
  } = data
  const classes = useStyles()

  return (
    <>
      <ButtonBase
        className={classes.tableRowMobile}
        component={LocalizedLink}
        to={`/channels/${channelID}/${channelCode}/details`}>
        <div>
          <Typography variant="h4">{name}</Typography>
        </div>
        <div>
          <Typography variant="body1">{displayChannelCode}</Typography>
        </div>
      </ButtonBase>
    </>
  )
}

export default ChannelRowMobile
